module.exports = __webpack_public_path__ + "static/media/480.345a540d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-measurement-tool/dark/480.png
// module id = 2238
// module chunks = 2